const WIDTH_SP = 769;
/* html読み込み直後の共通処理
-------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function(){
  // ページの表示
  var body = document.querySelector("body");
  body.style.opacity = "1";
  body.classList.remove("preload");

  // retina対応
  console.log("retina set");
  const retinaCheck = window.devicePixelRatio;
  let retinaimg = "";
  if (retinaCheck >= 2) {
    let target = document.getElementsByClassName('retina');
    for (let i = 0; i < target.length; i++) {
      if (target[i].getAttribute('src')) {
        retinaimg = target[i].getAttribute('src').replace(/\.(?=(?:png|jpg|jpeg).*$)/i, '--2x.');
      } else if (target[i].dataset.src) { // lazyload用
        retinaimg = target[i].dataset.src.replace(/\.(?=(?:png|jpg|jpeg).*$)/i, '--2x.');
      }
      target[i].setAttribute('srcset', retinaimg + ' 2x');
    }
  }

  /* FAQ開閉 ------- */
  const moreBtn = Array.from(document.querySelectorAll('.faq__item--q'));

  moreBtn.forEach((item) => {
    item.addEventListener('click', function () {
      this.classList.toggle('is-on');
      const target = this.nextElementSibling;

      if (target.style.maxHeight) {
        target.style.maxHeight = null;
      } else {
        target.style.maxHeight = target.scrollHeight + 'px';
      }
    });
  });

});

// スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var adjust = 0;
    var speed = 500; // ミリ秒
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});

/* 要素のフェード
-------------------------------------------------- */
window.addEventListener("load", doFade);
window.addEventListener("scroll", doFade);
function doFade() {
  let fadeInTarget = document.querySelectorAll(".js-fade-in");
  for (let i = 0; i < fadeInTarget.length; i++) {
    var elem = fadeInTarget[i];
    var rect = elem.getBoundingClientRect().top;
    var scroll = window.pageYOffset || document.documentElement.scrollTop;
    var offset = rect + scroll;
    var windowHeight = window.innerHeight; // 現在のブラウザの高さ
    // 実行時のディレイ
    var delay = elem.dataset.delay == undefined ? 0 : elem.dataset.delay;
    // 位置に関係なくload時に実行するかどうか
    var isLoad = elem.dataset.load == undefined ? false : elem.dataset.load;
    // 実行する位置
    var positionPc = elem.dataset.positionPc == undefined ? 200 : elem.dataset.positionPc;
    var positionSp = elem.dataset.positionSp == undefined ? 0 : elem.dataset.positionSp;
    var position = document.body.clientWidth > 751 ? positionPc : positionSp;
    var dispPosition = offset - windowHeight + position; // 実行位置
    // 速度
    var duration = elem.dataset.duration == undefined ? 1.5 : elem.dataset.duration;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add("js-scroll-in");
      elem.style.transitionDelay = delay + "s";
      elem.style.transitionDuration = duration + "s";
    }
  }
}

/* scrollでis-onクラスを付与する
-------------------------------------------------- */
window.addEventListener("load", setIsOn);
window.addEventListener("scroll", setIsOn);
function setIsOn() {
  let fadeInTarget = document.querySelectorAll(".js-scroll");
  for (let i = 0; i < fadeInTarget.length; i++) {
    const elem = fadeInTarget[i];
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight; // 現在のブラウザの高さ

    // 位置に関係なくload時に実行するかどうか
    const isLoad = elem.dataset.load == undefined ? false : elem.dataset.load;
    // 実行する位置
    const dispPosition = offset - windowHeight; // 実行位置

    if (scroll > dispPosition || isLoad) {
      elem.classList.add("is-on");
    }
  }
}

/**
 * 固定CTA
 */
window.addEventListener("load", dispCta);
window.addEventListener("scroll", dispCta);

function dispCta() {
  const fixedCta = document.getElementById("fixed-cta");
  const voice = document.getElementById("voice");
  const ctaElements = document.querySelectorAll(".cta, .cta2, .footer");

  const startPos = voice.getBoundingClientRect().top - (window.innerHeight / 2);

  const scroll = window.pageYOffset || document.documentElement.scrollTop;

  // cta クラスの要素が画面に見えているかを確認
  let isCtaVisible = false;
  ctaElements.forEach((cta) => {
    const rect = cta.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      isCtaVisible = true;
    }
  });

  // 固定CTAの表示/非表示の条件
  if (isCtaVisible || scroll <= startPos) {
    fixedCta.classList.remove("show");
  } else if (scroll > startPos) {
    fixedCta.classList.add("show");
  }
}